import { useLayoutEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default function GSAPProvider({ children }) {
  useLayoutEffect(() => {
    ScrollSmoother.get()?.kill();

    const smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 1.1,
      smoothTouch: 0.12,
      normalizeScroll: true,
      effects: true,
    });

    ScrollTrigger.refresh();

    return () => {
      // Only tear down what this provider owns. `ScrollTrigger.killAll()` used
      // to live here, and it destroyed every trigger in the app — including
      // ones components had already registered during the same mount pass,
      // which they never re-create. That silently disabled all scroll-driven
      // animation except in components that happened to mount later
      // (ScrollTrigger.getAll() returned a single trigger on the landing page).
      // Components create their triggers inside a gsap.context and revert it on
      // unmount, so they clean up after themselves.
      smoother.kill();
    };
  }, []);

  return (
    <div id="smooth-wrapper">
      <div id="smooth-content">{children}</div>
    </div>
  );
}
